import React, { FC } from 'react';
import { TableGroupModel, TableRowModel } from '../../../models/index.model';
import { TRowItemProps } from '../../../types/index.types';
import GroupRow from './groupRow';
import NormalRow from './normalRow';

const RowItems: FC<TRowItemProps> = (props) => {
  if (props.obj instanceof TableGroupModel) {
    return <GroupRow {...props} obj={props.obj} />;
  }

  if (props.obj instanceof TableRowModel) {
    return <NormalRow {...props} obj={props.obj} />;
  }

  return null;
};

export default React.memo(RowItems);
